import '@/mixin/mixin';
import Vue from 'vue';
import App from "./App.vue";
import { createStore } from "./store";
// import removeHttp from '@/mixin/base/removeHttp'

Vue.mixin({
  // mixins: [removeHttp],
  data: function data() {
    return {
      isMounted: false
    };
  },
  mounted: function mounted() {
    this.isMounted = true;
  }
});

// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
export function createApp(ctx) {
  // create store and router instances
  var store = createStore(ctx);
  store.dispatch('checkIsApp');

  // create the app instance.
  // here we inject the koa context, store to all child components,
  // making them available everywhere as `this.$ctx` and `this.$store`.
  var app = new Vue({
    store: store,
    render: function render(h) {
      return h('App');
    },
    components: {
      App: App
    }
  });

  // expose the app, the router and the store.
  // note we are not mounting the app here, since bootstrapping will be
  // different depending on whether we are in a browser or on the server.
  return {
    app: app,
    store: store
  };
}